import track_promise from "../../utils/track_promise"
import { Engine } from "./Engine"

export const {
  CreateRemoteFile,
  GenerateFile,
  MergePdf,
  PlotPdf,
  RasterizePdf,
  SplitPdf,
  ZipFiles,
} = Engine

export const RequestBlob = f =>
  track_promise(emit => Engine.RequestBlob(f, emit))
